import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const actionTypes = {
    AUDIT_ASSIGNMENTS_BULK_UPDATE_POST_FAILURE:
        "AUDIT_ASSIGNMENTS_BULK_UPDATE_POST_FAILURE",
    AUDIT_ASSIGNMENTS_BULK_UPDATE_POST_REQUEST:
        "AUDIT_ASSIGNMENTS_BULK_UPDATE_POST_REQUEST",
    AUDIT_ASSIGNMENTS_BULK_UPDATE_POST_SUCCESS:
        "AUDIT_ASSIGNMENTS_BULK_UPDATE_POST_SUCCESS",

    AUDIT_ASSIGNMENTS_CLEAR: "AUDIT_ASSIGNMENTS_CLEAR",

    AUDIT_ASSIGNMENTS_POST_FAILURE: "AUDIT_ASSIGNMENTS_POST_FAILURE",
    AUDIT_ASSIGNMENTS_POST_REQUEST: "AUDIT_ASSIGNMENTS_POST_REQUEST",
    AUDIT_ASSIGNMENTS_POST_SUCCESS: "AUDIT_ASSIGNMENTS_POST_SUCCESS",

    AUDIT_ASSIGNMENTS_PATCH_FAILURE: "AUDIT_ASSIGNMENTS_PATCH_FAILURE",
    AUDIT_ASSIGNMENTS_PATCH_REQUEST: "AUDIT_ASSIGNMENTS_PATCH_REQUEST",
    AUDIT_ASSIGNMENTS_PATCH_SUCCESS: "AUDIT_ASSIGNMENTS_PATCH_SUCCESS",

    AUDIT_ASSIGNMENTS_SET: "AUDIT_ASSIGNMENTS_SET"
};

export const actionCreators = {
    bulkUpdatePostRequest: (auditAssignments: Array<any>) => ({
        type: actionTypes.AUDIT_ASSIGNMENTS_BULK_UPDATE_POST_REQUEST,
        payload: { auditAssignments },
        [WAIT_FOR_ACTION]:
            actionTypes.AUDIT_ASSIGNMENTS_BULK_UPDATE_POST_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDIT_ASSIGNMENTS_BULK_UPDATE_POST_FAILURE
    }),
    bulkUpdatePostSuccess: (auditAssignments: Array<any>) => ({
        type: actionTypes.AUDIT_ASSIGNMENTS_BULK_UPDATE_POST_SUCCESS,
        payload: { auditAssignments }
    }),
    bulkUpdatePostFailure: (error) => ({
        type: actionTypes.AUDIT_ASSIGNMENTS_BULK_UPDATE_POST_FAILURE,
        error
    }),

    clear: () => ({
        type: actionTypes.AUDIT_ASSIGNMENTS_CLEAR
    }),

    postRequest: (auditAssignments: Array<any>) => ({
        type: actionTypes.AUDIT_ASSIGNMENTS_POST_REQUEST,
        payload: { auditAssignments },
        [WAIT_FOR_ACTION]: actionTypes.AUDIT_ASSIGNMENTS_POST_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDIT_ASSIGNMENTS_POST_FAILURE
    }),
    postSuccess: (auditAssignments: Array<any>) => ({
        type: actionTypes.AUDIT_ASSIGNMENTS_POST_SUCCESS,
        payload: { auditAssignments }
    }),
    postFailure: (error) => ({
        type: actionTypes.AUDIT_ASSIGNMENTS_POST_FAILURE,
        error
    }),

    patchRequest: (auditAssignmentId, orgId, status) => ({
        type: actionTypes.AUDIT_ASSIGNMENTS_PATCH_REQUEST,
        payload: { auditAssignmentId, orgId, status },
        [WAIT_FOR_ACTION]: actionTypes.AUDIT_ASSIGNMENTS_PATCH_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDIT_ASSIGNMENTS_PATCH_FAILURE
    }),
    patchSuccess: (data) => ({
        type: actionTypes.AUDIT_ASSIGNMENTS_PATCH_SUCCESS,
        payload: { data }
    }),
    patchFailure: (error) => ({
        type: actionTypes.AUDIT_ASSIGNMENTS_PATCH_FAILURE,
        error
    }),

    set: (auditAssignments: Array<any>) => ({
        type: actionTypes.AUDIT_ASSIGNMENTS_SET,
        payload: { auditAssignments }
    })
};

export default {
    create: actionCreators,
    type: actionTypes
};
